import {BaseAnimatedLayerService} from './base-animated-layer.service';

export class AnimatedLayerService extends BaseAnimatedLayerService {
  protected _nomsLayerLabel = 'animated';
}
